/** Telegram-style media bubble box: clamp WxH, reserve height before decode. */

export function fitMediaInside(
  w: number,
  h: number,
  maxW: number,
  maxH: number,
): { width: number; height: number } {
  const scale = Math.min(maxW / w, maxH / h, 1);
  return {
    width: Math.max(1, Math.round(w * scale)),
    height: Math.max(1, Math.round(h * scale)),
  };
}

/**
 * padding-bottom % of width — classic aspect lock.
 * Survives maxWidth:100% without fixed height (no squash / no 0-height collapse).
 */
export function aspectPaddingBottomPct(w: number, h: number): number {
  if (!(w > 0) || !(h > 0)) return 75;
  return (h / w) * 100;
}
